import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [TranslateModule]
})
export class FooterComponent {

  constructor() { }


  getCurrentYear() {
    return (new Date()).getFullYear();
  }

}
